/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import {
  IconButton,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tooltip,
  Snackbar,
  Typography,
  FormControl,
  InputLabel,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { Delete, Edit, Cancel, Check } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CRUDCapTinh from "../donvihanhchinh/components/formcaptinh";
import CRUDCapHuyen from "../donvihanhchinh/components/formcaphuyen";
import MenuItem from "@mui/material/MenuItem";
import { darken } from "@mui/material";
import { API_ROUTES, MenuProps, useStyles } from "../../../utils/constants";
import CustomTabPanel from "components/CustomPanel/customPanel";

import { useMaterialUIController, setHomePage } from "context";
import CRUDCapPhuong from "./components/formcapphuong";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ALLVALUE = { code: "ALL", name: "Tất cả" };
function DonVi() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenHuyen, setModalOpenHuyen] = useState(false);
  const [modalOpenPhuong, setModalOpenPhuong] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [tableData_quan, setTableData_Quan] = useState({});
  const [tableData_phuong, setTableData_Phuong] = useState({});
  const [provinceState, setProvinceState] = useState();
  const [districtState, setDistrictState] = useState();
  const [optionProvince, setOptionProvince] = useState();
  const [optionDistrict, setOptionDistrict] = useState();
  const [dataRow, setDataRow] = useState({});
  const [dataRowHuyen, setDataRowHuyen] = useState({});
  const [dataRowPhuong, setDataRowPhuong] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowHuyen, setSelectedRowHuyen] = useState(null);
  const [selectedRowPhuong, setSelectedRowPhuong] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [deleteConfirmationOpenHuyen, setDeleteConfirmationOpenHuyen] =
    useState(false);
  const [deleteConfirmationOpenPhuong, setDeleteConfirmationOpenPhuong] =
    useState(false);
  const [value, setValue] = React.useState(0);

  const handleDelete = async () => {
    try {
      const response = await axiosPrivateInstance.delete(
        "tinh/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      // setTableData([...tableData]);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };
  const handleDeleteHuyen = async () => {
    try {
      const response = await axiosPrivateInstance.delete(
        "huyen/" + selectedRowHuyen.id
      );
      // Remove the selected row from the data
      setTableData_Quan((prevData) =>
        prevData.filter((row) => row.id !== selectedRowHuyen.id)
      );
      // setTableData([...tableData]);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpenHuyen(false);
  };
  const handleDeletePhuong = async () => {
    try {
      const response = await axiosPrivateInstance.delete(
        "xa/" + selectedRowPhuong.id
      );
      setTableData_Phuong((prevData) =>
        prevData.filter((row) => row.id !== selectedRowPhuong.id)
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    setDeleteConfirmationOpenPhuong(false);
  };
  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };
  const handleOpenDeleteConfirmationHuyen = (row) => {
    setSelectedRowHuyen(row);
    setDeleteConfirmationOpenHuyen(true);
  };
  const handleOpenDeleteConfirmationPhuong = (row) => {
    setSelectedRowPhuong(row);
    setDeleteConfirmationOpenPhuong(true);
  };
  const handleCloseDeleteConfirmation = () => {
    setDeleteConfirmationOpen(false);
  };
  const handleCloseDeleteConfirmationHuyen = () => {
    setDeleteConfirmationOpenHuyen(false);
  };
  const handleCloseDeleteConfirmationPhuong = () => {
    setDeleteConfirmationOpenPhuong(false);
  };
  const handleSave = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "tinh/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData[values.rowIndex] = response.data;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "tinh",
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData.unshift(response.data);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setTableData([...tableData]);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = value;
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const handleSaveHuyen = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "huyen/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData_quan[values.rowIndex] = response.data;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "huyen",
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData_quan.unshift(response.data);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setTableData_Quan([...tableData_quan]);
      setValidationErrors({});
      setModalOpenHuyen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = value;
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const handleSavePhuong = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "xa/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData_phuong[values.rowIndex] = response.data;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "xa",
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData_phuong.unshift(response.data);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setTableData_Phuong([...tableData_phuong]);
      setValidationErrors({});
      setModalOpenPhuong(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = value;
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const fetchData = async () => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const response = await axiosPrivateInstance.get("tinh");
      setTableData(response.data);
      setOptionProvince(response.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  const fetchDataDistrict = async (tinh) => {
    if (!tableData_quan.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const response = await axiosPrivateInstance.get(
        "tinh/huyen?tinh=" + tinh
      );
      setTableData_Quan(response.data);
      setOptionDistrict(response.data);
      setDistrictState(ALLVALUE.code);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  const fetchDataState = async (tinh, huyen) => {
    if (!tableData_phuong.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const response = await axiosPrivateInstance.get(
        "huyen/xa?tinh=" + tinh + "&huyen=" + huyen
      );
      setTableData_Phuong(response.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  useEffect(() => {
    setProvinceState(ALLVALUE.code);
    fetchData();
    fetchDataDistrict(ALLVALUE.code);
    fetchDataState(ALLVALUE.code, ALLVALUE.code);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeProvince = (e) => {
    let { value } = e.target;
    setProvinceState(value);
    fetchDataDistrict(value);
    fetchDataState(value, ALLVALUE.code);
  };
  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    fetchDataState(provinceState, value);
    setDistrictState(value);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "ma",
        header: "Mã Tỉnh/Thành",
      },
      {
        accessorKey: "madinhdanh",
        header: "Mã định danh",
      },
      {
        accessorKey: "ten",
        header: "Tên Tỉnh/Thành",
      },
      {
        accessorKey: "sothutu",
        header: "Số thứ tự",
      },
      {
        accessorKey: "dientich",
        header: "Diện tích",
      },
      {
        accessorKey: "ghichu",
        header: "Ghi chú",
      },
    ],
    []
  );
  const columns_quan = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "tinh__ten",
        header: "Tỉnh/Thành",
      },
      {
        accessorKey: "ma",
        header: "Mã Quận/Huyện",
      },
      {
        accessorKey: "madinhdanh",
        header: "Mã định danh",
      },
      {
        accessorKey: "ten",
        header: "Tên Quận/Huyện",
      },
      {
        accessorKey: "sothutu",
        header: "Số thứ tự",
      },
      {
        accessorKey: "dientich",
        header: "Diện tích",
      },
    ],
    []
  );
  const columns_phuong = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "huyen__ten",
        header: "Quận/Huyện",
      },
      {
        accessorKey: "ma",
        header: "Mã Phường/Xã",
      },
      {
        accessorKey: "madinhdanh",
        header: "Mã định danh",
      },
      {
        accessorKey: "ten",
        header: "Tên Phường/Xã",
      },
      {
        accessorKey: "sothutu",
        header: "Số thứ tự",
      },
      {
        accessorKey: "dientich",
        header: "Diện tích",
      },
    ],
    []
  );
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get("tinh/" + id);
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa đơn vị hành chính cấp tỉnh");
    setValidationErrors({});
    setModalOpen(true);
  };
  const handelEditClickHuyen = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get("huyen/" + id);
      setDataRowHuyen({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa đơn vị hành chính cấp huyện");
    setValidationErrors({});
    setModalOpenHuyen(true);
  };
  const handelEditClickPhuong = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get("xa/" + id);
      setDataRowPhuong({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa đơn vị hành chính cấp phường/xã");
    setValidationErrors({});
    setModalOpenPhuong(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="primary"
          variant="fullWidth"
          aria-label="basic tabs example"
        >
          <Tab label="Tỉnh/Thành phố" {...a11yProps(0)} />
          <Tab label="Quận/Huyện" {...a11yProps(1)} />
          <Tab label="Phường/Xã" {...a11yProps(2)} />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <MaterialReactTable
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Lỗi khi lấy dữ liệu",
                  }
                : undefined
            }
            enableRowNumbers
            rowNumberMode="static"
            columns={columns}
            data={tableData}
            enableFilters={true}
            enableHiding={false}
            enableColumnOrdering={false}
            enableDensityToggle={true}
            enableColumnResizing
            enableGrouping
            muiToolbarAlertBannerChipProps={{ color: "success" }}
            enableEditing
            localization={MRT_Localization_VI}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex" }}>
                <Tooltip arrow placement="left" title="Chỉnh sửa">
                  <IconButton color="info" onClick={() => handelEditClick(row)}>
                    <Edit />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="right" title="Xoá">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      let _data = [];
                      _data["id"] = row.getValue("id");
                      _data["ten"] = row.getValue("ten");
                      handleOpenDeleteConfirmation(_data);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            renderTopToolbarCustomActions={() => (
              <Stack spacing={2} direction="row" color="white">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ color: "#ffffff" }}
                  onClick={() => {
                    setAction("New");
                    setTitle("Thêm mới Tỉnh/Thành phố");
                    setDataRow({});
                    setValidationErrors({});
                    setModalOpen(true);
                  }}
                >
                  Tạo mới
                </Button>
              </Stack>
            )}
            initialState={{
              expanded: true, //expand all groups by default
              isLoading: true,
              //sorting: [{ id: "tenduong", desc: true }], //sort by state by default
              pagination: { pageIndex: 0, pageSize: 10 },
              columnVisibility: {
                id: false,
              },
              density: "compact",
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": {
                muiTableHeadCellProps: {
                  align: "center",
                },
                muiTableBodyCellProps: {
                  align: "center",
                },
                size: 80,
              },
            }}
            state={{
              // columnFilters,
              // globalFilter,
              isLoading,
              // pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              // sorting,
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid rgb(211 225 245)",
                backgroundColor: "#fff",
              },
            }}
            muiTableBodyProps={{
              sx: (theme) => ({
                "& tr:nth-of-type(odd)": {
                  backgroundColor: darken(
                    theme.palette.background.default,
                    0.1
                  ),
                },
              }),
            }}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Box
            pt={6}
            py={3}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              px: 3,
            }}
          >
            <Grid
              container
              spacing={2}
              rowSpacing={2}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} md={5} lg={5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="label-tinh">Tỉnh</InputLabel>
                  <Select
                    sx={{ padding: "0.7rem" }}
                    labelId="label-tinh"
                    value={provinceState ? provinceState : ALLVALUE.code}
                    label="Tỉnh"
                    defaultValue={ALLVALUE.code}
                    MenuProps={MenuProps}
                    onChange={handleChangeProvince}
                  >
                    <MenuItem value={ALLVALUE.code}>Tất cả</MenuItem>
                    {optionProvince &&
                      optionProvince?.map((item) => (
                        <MenuItem key={item.id} value={item.ma}>
                          {item.ten}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <MaterialReactTable
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Lỗi khi lấy dữ liệu",
                  }
                : undefined
            }
            enableRowNumbers
            rowNumberMode="static"
            columns={columns_quan}
            data={tableData_quan}
            enableFilters={true}
            enableHiding={false}
            enableColumnOrdering={false}
            enableDensityToggle={true}
            enableColumnResizing
            enableGrouping
            muiToolbarAlertBannerChipProps={{ color: "success" }}
            enableEditing
            localization={MRT_Localization_VI}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex" }}>
                <Tooltip arrow placement="left" title="Chỉnh sửa">
                  <IconButton
                    color="info"
                    onClick={() => handelEditClickHuyen(row)}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="right" title="Xoá">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      let _data = [];
                      _data["id"] = row.getValue("id");
                      _data["ten"] = row.getValue("ten");
                      handleOpenDeleteConfirmationHuyen(_data);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            renderTopToolbarCustomActions={() => (
              <Stack spacing={2} direction="row" color="white">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ color: "#ffffff" }}
                  onClick={() => {
                    setAction("New");
                    setTitle("Thêm mới Quận/Huyện");
                    setDataRowHuyen({});
                    setValidationErrors({});
                    setModalOpenHuyen(true);
                  }}
                >
                  Tạo mới
                </Button>
              </Stack>
            )}
            initialState={{
              expanded: true, //expand all groups by default
              isLoading: true,
              //sorting: [{ id: "tenduong", desc: true }], //sort by state by default
              pagination: { pageIndex: 0, pageSize: 10 },
              columnVisibility: {
                id: false,
              },
              density: "compact",
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": {
                muiTableHeadCellProps: {
                  align: "center",
                },
                muiTableBodyCellProps: {
                  align: "center",
                },
                size: 80,
              },
            }}
            state={{
              // columnFilters,
              // globalFilter,
              isLoading,
              // pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              // sorting,
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid rgb(211 225 245)",
                backgroundColor: "#fff",
              },
            }}
            muiTableBodyProps={{
              sx: (theme) => ({
                "& tr:nth-of-type(odd)": {
                  backgroundColor: darken(
                    theme.palette.background.default,
                    0.1
                  ),
                },
              }),
            }}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <Box
            pt={6}
            py={3}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              px: 3,
            }}
          >
            <Grid
              container
              spacing={2}
              rowSpacing={2}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} md={5} lg={5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="label-tinh">Tỉnh</InputLabel>
                  <Select
                    sx={{ padding: "0.7rem" }}
                    labelId="label-tinh"
                    value={provinceState ? provinceState : ALLVALUE.code}
                    label="Tỉnh"
                    defaultValue={ALLVALUE.code}
                    MenuProps={MenuProps}
                    onChange={handleChangeProvince}
                  >
                    <MenuItem value={ALLVALUE.code}>Tất cả</MenuItem>
                    {optionProvince &&
                      optionProvince?.map((item) => (
                        <MenuItem key={item.id} value={item.ma}>
                          {item.ten}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <FormControl fullWidth size="small">
                  <InputLabel id="label-tinh">Quận/Huyện</InputLabel>
                  <Select
                    sx={{ padding: "0.7rem" }}
                    labelId="label-tinh"
                    value={districtState ? districtState : ALLVALUE.code}
                    label="Quận/Huyện"
                    // defaultValue={ALLVALUE.code}
                    MenuProps={MenuProps}
                    onChange={handleChangeDistrict}
                  >
                    <MenuItem value={ALLVALUE.code}>Tất cả</MenuItem>
                    {optionDistrict &&
                      optionDistrict?.map((item) => (
                        <MenuItem key={item.id} value={item.ma}>
                          {item.ten}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <MaterialReactTable
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Lỗi khi lấy dữ liệu",
                  }
                : undefined
            }
            enableRowNumbers
            rowNumberMode="static"
            columns={columns_phuong}
            data={tableData_phuong}
            enableFilters={true}
            enableHiding={false}
            enableColumnOrdering={false}
            enableDensityToggle={true}
            enableColumnResizing
            enableGrouping
            muiToolbarAlertBannerChipProps={{ color: "success" }}
            enableEditing
            localization={MRT_Localization_VI}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex" }}>
                <Tooltip arrow placement="left" title="Chỉnh sửa">
                  <IconButton
                    color="info"
                    onClick={() => handelEditClickPhuong(row)}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="right" title="Xoá">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      let _data = [];
                      _data["id"] = row.getValue("id");
                      _data["ten"] = row.getValue("ten");
                      handleOpenDeleteConfirmationPhuong(_data);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            renderTopToolbarCustomActions={() => (
              <Stack spacing={2} direction="row" color="white">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ color: "#ffffff" }}
                  onClick={() => {
                    setAction("New");
                    setTitle("Thêm mới Phường/Xã");
                    setDataRowPhuong({});
                    setValidationErrors({});
                    setModalOpenPhuong(true);
                  }}
                >
                  Tạo mới
                </Button>
              </Stack>
            )}
            initialState={{
              expanded: true, //expand all groups by default
              isLoading: true,
              //sorting: [{ id: "tenduong", desc: true }], //sort by state by default
              pagination: { pageIndex: 0, pageSize: 10 },
              columnVisibility: {
                id: false,
              },
              density: "compact",
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": {
                muiTableHeadCellProps: {
                  align: "center",
                },
                muiTableBodyCellProps: {
                  align: "center",
                },
                size: 80,
              },
            }}
            state={{
              // columnFilters,
              // globalFilter,
              isLoading,
              // pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              // sorting,
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid rgb(211 225 245)",
                backgroundColor: "#fff",
              },
            }}
            muiTableBodyProps={{
              sx: (theme) => ({
                "& tr:nth-of-type(odd)": {
                  backgroundColor: darken(
                    theme.palette.background.default,
                    0.1
                  ),
                },
              }),
            }}
          />
        </CustomTabPanel>
        <CRUDCapTinh
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
        />
        <CRUDCapHuyen
          data={dataRowHuyen}
          open={modalOpenHuyen}
          title={title}
          onClose={() => {
            setModalOpenHuyen(false);
            setValidationErrors({});
          }}
          onSubmitHuyen={handleSaveHuyen}
          validationErrors={validationErrors}
          action={action}
          dataOptionProvince={optionProvince}
        />
        <CRUDCapPhuong
          data={dataRowPhuong}
          open={modalOpenPhuong}
          title={title}
          onClose={() => {
            setModalOpenPhuong(false);
            setValidationErrors({});
          }}
          onSubmitPhuong={handleSavePhuong}
          validationErrors={validationErrors}
          action={action}
          dataOptionProvince={optionProvince}
          dataOptionDistrict={optionDistrict}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tên: {selectedRow?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteConfirmationOpenHuyen}
          onClose={handleCloseDeleteConfirmationHuyen}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tên: {selectedRowHuyen?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmationHuyen}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDeleteHuyen}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteConfirmationOpenPhuong}
          onClose={handleCloseDeleteConfirmationPhuong}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tên: {selectedRowPhuong?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmationPhuong}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDeletePhuong}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DonVi;
